
import { defineComponent } from "vue";
import { RouteLocationNormalizedLoaded, RouteRecordRaw } from "vue-router";
import NavigationBar from "@/components/layout/NavigationBar.vue";
import Loader from "@/components/layout/Loader.vue";
import ColorTheme from "@/components/layout/ColorTheme.vue";
import { routes } from "./router";
import { IComponentsNavigationBarConfig } from "./types";

const METHOD_NAME_COMPONENTS_NAV_BAR_CONFIG = "getNavigationBarConfig";

export default defineComponent({
  name: "App",
  components: {
    NavigationBar,
    Loader,
    ColorTheme,
  },
  data() {
    return {
      navigationBarConfig: {} as IComponentsNavigationBarConfig,
    };
  },
  mounted() {
    this.updateNavigationBarOnRouteChange();
  },
  methods: {
    updateNavigationBarOnRouteChange() {
      this.$watch(
        () => this.$route,
        (to: RouteLocationNormalizedLoaded) => {
          function findRoute(path: string, routes: Array<RouteRecordRaw>, basePath = ""): RouteRecordRaw | void {
            for (const route of routes) {
              if (basePath + route.path === path) return route;
              if (path.startsWith(basePath + route.path) && route.children) {
                // DFS: search for matching route in children
                const match = findRoute(path, route.children, `${basePath}${route.path}/`);
                if (match) return match;
              }
            }
          }
          const currentRoute = findRoute(to.path, routes);
          if (currentRoute) {
            // eslint-disable-next-line
            const component = currentRoute.component as any;
            if (component && component.methods && typeof component.methods[METHOD_NAME_COMPONENTS_NAV_BAR_CONFIG] === "function") {
              const config = component.methods[METHOD_NAME_COMPONENTS_NAV_BAR_CONFIG]() as IComponentsNavigationBarConfig;
              this.navigationBarConfig = config;
              return;
            }
          }
          this.navigationBarConfig = {};
        }
      );
    },
  },
});
